<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="检查项" prop="examineItemName">
                <el-input v-model="dataForm.examineItemName" placeholder="检查项名称"></el-input>
            </el-form-item>
            <el-form-item label="学校" prop="schoolId" v-if="schoolVisible">
                <el-select v-model="dataForm.schoolId" placeholder="请选择学校" clearable @change="getExamineTypeList">
                    <el-option v-for="school in schoolList" :label="school.schoolName" :value="school.id"
                               :key="school.id" ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="检查类型" prop="examineTypeId">
                <el-select v-model="dataForm.examineTypeId" placeholder="请选择" clearable>
                    <el-option v-for="examineType in examineTypeList" :label="examineType.examineTypeName" :value="examineType.id"
                               :key="examineType.id" ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分数" prop="score">
                <el-input v-model="dataForm.score" placeholder="分数"></el-input>
            </el-form-item>
            <el-form-item label="照片必填 " prop="isNeedImg">
                <el-switch
                        v-model="dataForm.isNeedImg"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="是"
                        inactive-text="否"
                        :active-value="1"
                        :inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="备注必填" prop="isNeedNote">
                <el-switch
                        v-model="dataForm.isNeedNote"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="是"
                        inactive-text="否"
                        :active-value="1"
                        :inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="分数限制 " prop="isNotify">
            <el-switch
                v-model="dataForm.isStart"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0">
            </el-switch>
        </el-form-item>
            <el-form-item label="最高分数" v-if="dataForm.isStart===1" prop="scoreSet">
                <el-input v-model.trim="dataForm.maxScore" placeholder="请输入整数"></el-input>
            </el-form-item>
            <el-form-item label="最低分数" v-if="dataForm.isStart===1" prop="scoreSet">
                <el-input v-model.trim="dataForm.minScore" placeholder="请输入整数"></el-input>
            </el-form-item>
            <el-form-item label="评价次数限制 " prop="isNotify">
                <el-switch
                    v-model="dataForm.isCountLimit"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="是"
                    inactive-text="否"
                    :active-value="1"
                    :inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="评价次数" v-if="dataForm.isCountLimit===1" prop="scoreSet">
                <el-input v-model.trim="dataForm.countSet" placeholder="请输入整数"></el-input>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      visible: false,
      schoolVisible: false,
      schoolList: [],
      examineTypeList: [],
      dataForm: {
        id: '',
        examineItemName: '',
        examineTypeId: '',
        examineTypeName: '',
        score: '',
        createDate: '',
        schoolId: '',
        isNeedImg: '',
        isNeedNote: '',
        isStart: '',
        maxScore: '',
        minScore: '',
        isCountLimit: '',
        countSet: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        examineItemName: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        examineTypeId: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        examineTypeName: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        score: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.resetValue()
        this.getExamineTypeList()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/classEvaluate/examineItem/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.getExamineTypeList()
      }).catch(() => {
      })
    },
    resetValue () {
      this.dataForm.schoolId = ''
      this.schoolVisible = false
    },
    // 获取学校的集合
    getSchoolList () {
      this.$http.get('/school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类型集合
    getExamineTypeList () {
      this.$http.post(`classEvaluate/examineType/getExamineTypeList?schoolId=${this.dataForm.schoolId}`).then(({ data: res }) => {
        if (res.code !== 0) {
          if (res.code === 10050) {
            this.schoolVisible = true
            this.getSchoolList()
          }
          return this.$message.error(res.msg)
        }
        this.examineTypeList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        // 正整数的正则表达式
        // const r = /^\+?[0-9][0-9]*$/ // 正整数
        // // 如果判断不符合正则，则不是正整数不能提交
        // if (!r.test(this.dataForm.score)) {
        //   return this.$message.error('数量必须为正整数')
        // }
        // 一位小数的正则表达式
        const r = /^[+-]?(0|([1-9]\d*))(\.\d{1})?$/
        if (!r.test(this.dataForm.score)) {
          return this.$message.error('最多支持小数点后一位')
        }
        this.dataForm.examineTypeName = this.examineTypeList.filter((e) => { return e.id === this.dataForm.examineTypeId })[0].examineTypeName
        console.log(this.dataForm.examineTypeName)
        this.$http[!this.dataForm.id ? 'post' : 'put'](`/classEvaluate/examineItem?schoolId=${this.dataForm.schoolId}`, this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, {
      leading: true,
      trailing: false
    })
  }
}
</script>
